import { Routes } from '@angular/router';

export const authRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./auth').then((m) => m.Auth),
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        loadComponent: () => import('./components/login/login').then((m) => m.Login),
      },
      {
        path: 'forget-password',
        loadComponent: () =>
          import('./components/forget-password/forget-password').then((m) => m.ForgetPassword),
      },
      {
        path: 'verify',
        loadComponent: () => import('./components/verify/verify').then((m) => m.Verify),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./components/reset-password/reset-password').then((m) => m.ResetPassword),
      },
      {
        path: 'change-first-password',
        loadComponent: () =>
          import('./components/change-first-password/change-first-password').then((m) => m.ChangeFirstPassword),
      },
    ],
  },
];
